export function Camera(props) {
  return 
}

export function useCameraDevice() {
  return false
}

export function useCodeScanner() {
  return false
}